"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionHeading = exports.StyledAccordionHeader = exports.StyledAccordionContent = exports.StyledAccordionButton = exports.StyledAccordion = void 0;
var _ChevronRight = _interopRequireDefault(require("@tvg/fuse-icons/lib/ChevronRight"));
var _fuseUtils = require("@tvg/fuse-utils");
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _typography = require("../../fuse-typography-element/src/typography");
var _accordionConfig = _interopRequireDefault(require("./accordion-config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var iconSizeConfig = _accordionConfig["default"].icon;
var StyledAccordion = exports.StyledAccordion = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hideBorder';
  }
}).attrs({
  className: 'fuse-accordion'
}).withConfig({
  displayName: "styled-accordion__StyledAccordion",
  componentId: "sc-201m4c-0"
})(["", ""], function (_ref) {
  var hideBorder = _ref.hideBorder;
  return "\n\t\tborder-top: ".concat(hideBorder ? "none" : "1px solid var(--color-global-grey400)", ";\n\n\t\t&:last-of-type {\n\t\t\tborder-bottom: ").concat(hideBorder ? "none" : "1px solid var(--color-global-grey400)", ";\n\t\t}\n\n\t\t&.fuse-accordion__closed:hover {\n\t\t\tborder-color: var(--color-brand-mid);\n\t\t}\n\n\t\t&.fuse-accordion__closed:hover + .fuse-accordion {\n\t\t\tborder-top: ").concat(hideBorder ? "none" : "1px solid var(--color-brand-mid)", ";\n\t\t}\n\t");
});
var StyledAccordionHeader = exports.StyledAccordionHeader = _styledComponents["default"].h3.attrs({
  className: 'fuse-accordion__header',
  'data-testid': 'fuse-accordion__header'
}).withConfig({
  displayName: "styled-accordion__StyledAccordionHeader",
  componentId: "sc-201m4c-1"
})([""]);
var StyledAccordionButton = exports.StyledAccordionButton = _styledComponents["default"].button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['titleSize', 'open'].includes(prop);
  }
}).attrs({
  className: 'fuse-accordion__button',
  'data-testid': 'fuse-accordion__button'
}).withConfig({
  displayName: "styled-accordion__StyledAccordionButton",
  componentId: "sc-201m4c-2"
})(["", ""], function (_ref2) {
  var open = _ref2.open,
    titleSize = _ref2.titleSize;
  var setViewportCSS = (0, _fuseUtils.buildResponsiveSize)(titleSize)[1];
  var getIconSizeCSS = function getIconSizeCSS(viewportSize) {
    var height = iconSizeConfig[viewportSize];
    return "\n\t\t\t\t&:after {\n\t\t\t\t\tflex: 0 0 ".concat(height, ";\n\t\t\t\t\theight: ").concat(height, ";\n\t\t\t\t}\n\t\t    ");
  };
  var viewportIconCSS = setViewportCSS(getIconSizeCSS);
  return "\n\t\t\talign-items: center;\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\tpadding: var(--spacing-global-space5) 0;\n\t\t\ttext-align: left;\n\t\t\twidth: 100%;\n\t\t\n\t\t\t&:focus .fuse-accordion__heading,\n\t\t\t&:hover .fuse-accordion__heading {\n\t\t\t\tcolor: var(--color-brand-mid);\n\t\t\t}\n\t\t\n\t\t\t&:focus:after,\n\t\t\t&:hover:after {\n\t\t\t\tbackground: var(--color-brand-mid);\n\t\t\t}\n\t\t\n\t\t\t&:focus-visible,\n\t\t\t&:active {\n\t\t\t\toutline: var(--spacing-global-space1) solid var(--color-functional-focus);\n\t\t\t}\n\t\t\n\t\t\t&:focus:not(:focus-visible) {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t\n\t\t\t&:after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\tflex: 0 0 ".concat(_iconElement.iconElementConfig.small.height, ";\n\t\t\t\theight: ").concat(_iconElement.iconElementConfig.small.height, ";\n\t\t\t\tmask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null))), "')\n\t\t\t\t\tcenter/cover no-repeat;\n\t\t\t\t-webkit-mask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null))), "')\n\t\t\t\t\tcenter/cover no-repeat;\n\t\t\t\tbackground: var(--color-global-black);\n\t\t\t\ttransform: rotate(").concat(open ? '-90deg' : '90deg', ");\n\t\t\t\ttransition-duration: 300ms;\n\t\t\t}\n\t\t\n\t\t\t/* Overriding flex-basis and height of icon pseudo element in button based on different viewports */\n\t\t\t").concat(viewportIconCSS, "\n\t\t");
});
var StyledAccordionHeading = exports.StyledAccordionHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'chevronInline';
  }
}).attrs({
  className: 'fuse-accordion__heading',
  'data-testid': 'fuse-accordion__heading'
}).withConfig({
  displayName: "styled-accordion__StyledAccordionHeading",
  componentId: "sc-201m4c-3"
})(["flex:", ";margin-right:var(--spacing-global-space3);"], function (_ref3) {
  var chevronInline = _ref3.chevronInline;
  return chevronInline ? "unset" : "1 1 auto";
});
var StyledAccordionContent = exports.StyledAccordionContent = _styledComponents["default"].div.attrs({
  className: 'fuse-accordion__content',
  'data-testid': 'fuse-accordion__content'
}).withConfig({
  displayName: "styled-accordion__StyledAccordionContent",
  componentId: "sc-201m4c-4"
})(["padding-bottom:var(--spacing-global-space6);&.fuse-acccordion__content--hide{display:none;}"]);